import { FormEvent, useEffect, useRef, useState, ClipboardEvent } from "react";
import useWebOtp from "hooks/useWebOtp";

import { fixNumbers } from "common/common";

const OtpInputs = ({ error, setSmsCode }: any) => {
  const [OtpCode, setOtpCode] = useState<string[]>(["", "", "", "", ""]);
  const inpRef = useRef<any>([]);

  useEffect(() => {
    if (OtpCode.some((v) => v !== "")) {
      setSmsCode(OtpCode);
    }
  }, [OtpCode]);

  useWebOtp(setOtpCode);
  // method

  const handleAutofillOrPasteCode = (value: string) => {
    const pastedChars = value.slice(0, 5).split("").reverse();
    setOtpCode((prev: any[]) => {
      const newState = [...prev];
      pastedChars.forEach((char: string, i: number) => {
        if (i < 5) {
          newState[i] = char;
        }
      });
      return [...newState];
    });

    // Focus on the last filled input
    const focusIndex = Math.min(pastedChars.length - 1, 4);
    if (focusIndex >= 0 && inpRef.current[focusIndex]) {
      setTimeout(() => inpRef.current[focusIndex].focus(), 0);
    }
  };

  const handleInput = (e: FormEvent<HTMLInputElement>, index: number) => {
    const input = e.currentTarget;
    const value = fixNumbers(input.value);

    // Check if multiple characters were entered (autofill or paste)
    if (value.length > 1) {
      e.preventDefault();
      handleAutofillOrPasteCode(value);
      // Clear the input to prevent display issues
      input.value = "";
    }
  };

  const changeOtpCode = (e: any, index: any) => {
    // Check if multiple characters were entered (paste operation)
    if (e.length > 1) {
      handleAutofillOrPasteCode(e);
    } else if (e.length === 1) {
      // Single character input
      setOtpCode((prev: any[]) => {
        const newState = [...prev];
        newState[index] = e;
        if (index !== 0 && e !== "") {
          inpRef.current[index - 1].focus();
        }
        return [...newState];
      });
    }
  };

  const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedData = fixNumbers(e.clipboardData.getData("text"));
    handleAutofillOrPasteCode(pastedData);
  };
  const requiredVerifyPassword = (value: any) => {
    if (value === 0 || value === "" || value === undefined || value === null) {
      return { error: true };
    } else {
      return { error: false };
    }
  };

  return (
    <div className="verifyInputsContainer">
      {[1, 2, 3, 4, 5].map((inp, index) => (
        <input
          value={OtpCode[index]}
          autoComplete={index === 4 ? "one-time-code" : "off"}
          key={index}
          inputMode="numeric"
          ref={(el) => (inpRef.current[index] = el)}
          maxLength={index === 4 ? 5 : 1}
          className={
            error && requiredVerifyPassword(OtpCode[index]).error
              ? "verifyInputValidation"
              : "verifyInput"
          }
          onInput={(e) => handleInput(e, index)}
          onChange={(e) => changeOtpCode(fixNumbers(e.target.value), index)}
          onPaste={(e) => handlePaste(e)}
        />
      ))}
    </div>
  );
};
export default OtpInputs;
